import React, {Component} from 'react'
import {Modal, Form, Row, Col, Input, Button, Select} from 'antd'
import forumlaInfoAPI from '../../apis/forumlaInfo'
import {Base64} from 'js-base64'
import {withTranslation} from 'react-i18next'

const {TextArea} = Input

class FormModal extends Component {
  formRef = React.createRef()

  state = {
    formulaTypeIdOption: []
  }

  componentDidMount() {
    forumlaInfoAPI.getFormulaTypeAction().then(res => {
      this.setState({
        formulaTypeIdOption: res.data.data
      })
    })
  }

  handleOk = () => {
    const {handleCancel, handleSearch} = this.props
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        name: fieldsValue.name,
        examples: fieldsValue.examples,
        description: fieldsValue.description,
        formulaTypeId: fieldsValue.formulaTypeId,
        importClass: fieldsValue.importClass ? Base64.encode(fieldsValue.importClass) : null,
        groovyScript: Base64.encode(fieldsValue.groovyScript)
      }
      forumlaInfoAPI.addAction(params).then(res => {
        handleCancel('addModalVisible')
        handleSearch()
      })

    }).catch(err => { })
  }

  render() {
    const {addModalVisible, handleCancel, t} = this.props
    return (
      <>
        <Modal
          title={`${t(`general.add`)} ${t(`formulaInfo.formulaInfo`)}`}
          closable={true}
          width="70%"
          onCancel={() => { handleCancel('addModalVisible') }}
          visible={addModalVisible}
          maskClosable={false}
          destroyOnClose={true}
          centered
          footer={[
            <Button key="Save" type="primary" onClick={this.handleOk}>{t(`general.save`)}</Button>,
            <Button key="Cancel" onClick={() => { handleCancel('addModalVisible') }}>{t(`general.cancel`)}</Button>,
          ]}
        >
          <Form ref={this.formRef} key="addMapping" layout="vertical">
            <Row justify="start" gutter={[10, 0]}>
              <Col span={12}>
                <Form.Item name="name" label={t(`formulaInfo.name`)}
                           rules={[{required: true, message: `${t(`general.pleaseEnter`)} ${t(`formulaInfo.name`)}`, pattern: new RegExp(/\S/)}]}>
                  <Input maxLength={100} placeholder={t(`general.pleaseEnter`)}/>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="formulaTypeId" label={t(`formulaInfo.formulaType`)}
                           rules={[{
                             required: true,
                             message: `${t(`general.pleaseSelect`)} ${t(`formulaInfo.formulaType`)}`,
                             pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                           }]}>
                  <Select placeholder={t(`general.pleaseSelect`)} allowClear>
                    {
                      this.state.formulaTypeIdOption.map((e, i) => {
                        return (
                          <Select.Option key={e.id} value={e.id}>{e.name}</Select.Option>
                        )
                      })
                    }
                  </Select>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item name="examples" label={t(`formulaInfo.examples`)}
                           rules={[{required: true, message: `${t(`general.pleaseEnter`)} ${t(`formulaInfo.examples`)}`, pattern: new RegExp(/\S/)}]}>
                  <TextArea rows={5}/>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item name="description" label={t(`formulaInfo.description`)}
                           rules={[{
                             required: true,
                             message: `${t(`general.pleaseEnter`)} ${t(`formulaInfo.description`)}`,
                             pattern: new RegExp(/\S/)
                           }]}>
                  <TextArea rows={5}/>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item name="importClass" label={t(`formulaInfo.importClass`)}>
                  <TextArea rows={5}/>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item name="groovyScript" label={t(`formulaInfo.groovyScript`)}
                           rules={[{
                             required: true,
                             message: `${t(`general.pleaseEnter`)} ${t(`formulaInfo.groovyScript`)}`,
                             pattern: new RegExp(/\S/)
                           }]}>
                  <TextArea rows={5}/>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormModal)
